<template>
  <div class="title">
    <div class="text-primary title-text">{{ propsData.title }}</div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  data() {
    return {
      fontSize: 100,
    };
  },
  props: {
    propsData: {
      default: () => ({
        title: ''
      })
    },
  },
};
</script>

<style scoped lang='less'>
.title {
  padding: 0 @spacing-medium @spacing-small;
  font-weight: bold;
  text-align: justify;
  word-break: break-word;

  &-text {
    line-height: 1.4;
  }
}

.night {
  .text-primary {
    color: @dark-color-text-primary;
  }
}
</style>
